import { render, staticRenderFns } from "./VesselRecordAgePieChart.vue?vue&type=template&id=346e5426&scoped=true&"
import script from "./VesselRecordAgePieChart.vue?vue&type=script&lang=js&"
export * from "./VesselRecordAgePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e5426",
  null
  
)

export default component.exports